import React from "react";

import type { Asset, Certificate } from "../../graphql-types";
import { useLexicon } from "../context/LexiconContext";
import ExternalLink from "./ExternalLink";
import Image from "./GatsbyImage";
import Heading from "./Heading";

type Props = {
  certificates?: (Pick<Certificate, "title" | "url"> & {
    image: Pick<Asset, "description" | "gatsbyImageData">;
  })[];
};

const Certificates: React.FC<Props> = ({ certificates }) => {
  const lexicon = useLexicon();
  if (!certificates || certificates.length === 0) {
    return null;
  }

  return (
    <section
      data-testid="certificates-section"
      className="max-w-container mx-auto"
    >
      {lexicon.certificates && (
        <Heading as="h2" className="p-10 text-2xl md:text-3xl md:p-14">
          {lexicon.certificates}
        </Heading>
      )}
      <ul className="flex flex-wrap justify-center max-w-lg px-10 m-auto certificate__wrapper">
        {certificates.map(
          ({ image: { description: alt, gatsbyImageData }, title, url }) => (
            <li key={title} className="w-1/2 p-2 sm:w-1/4 lg:p-4">
              {url ? (
                <ExternalLink
                  href={url}
                  title={title}
                  showExternalIcon={false}
                  className="flex-1"
                >
                  <Image image={gatsbyImageData} alt={alt || ""} />
                </ExternalLink>
              ) : (
                <Image image={gatsbyImageData} alt={alt || ""} />
              )}
            </li>
          )
        )}
      </ul>
    </section>
  );
};

export default Certificates;
